export default {
      id: "nav-home-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#nav-home",
      toString: function () {
        return this.url;
      }
    }